import { useQuery } from 'react-query';
import { useAuth0 } from '@auth0/auth0-react';
import setToken from '../../utils/api';
import { AiStatus } from '../../types/IAiConversation';

// Whether the assistant is configured on this environment. Decided at API startup, so it is
// cached for the session.
export default function useAiStatus() {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<AiStatus, Error>(
    ['ai-status'],
    async () => {
      const token = await getAccessTokenSilently();
      const api = await setToken(token);
      const response = await api.get<AiStatus>('api/ai/status');
      if (response.status !== 200)
        throw new Error('Could not load the assistant status');
      return response.data;
    },
    { staleTime: 5 * 60 * 1000, refetchOnWindowFocus: false },
  );
}
